module.exports = {
  siteMetadata: {
    siteUrl: "https://www.playdarktide.com",
    title: "Darktide Website",
  },
  plugins: [
    {
      resolve: "gatsby-plugin-manifest",
      options: {
        name: "Darktide",
        short_name: "Darktide",
        description:
          "Warhammer 40,000: Darktide is the new co-op focused experience from the award-winning team behind the Vermintide series.",
        start_url: "/",
        background_color: "#fff",
        theme_color: "#ffcc00",
        display: "standalone",
        icon: "src/images/DT-favicon-grad.svg",
      },
    },
    {
      resolve: "gatsby-source-storyblok",
      options: {
        accessToken:
          process.env.NODE_ENV === "production"
            ? process.env.SB_PUBLIC_KEY
            : process.env.GATSBY_SB_PREVIEW_KEY,
        previewAccessToken: process.env.GATSBY_SB_PREVIEW_KEY,
        resolveLinks: "story",
        resolve_links: "url",
        homeSlug: "home",
        resolveRelations: ["news_post.author"],
        version: process.env.NODE_ENV === "production" ? "published" : `draft`,
      },
    },
    {
      resolve: "gatsby-plugin-i18n",
      options: {
        langKeyForNull: "uk",
        langKeyDefault: "uk",
        useLangKeyLayout: true,
        prefixDefault: false,
      },
    },
    {
      resolve: `gatsby-plugin-force-trailing-slashes`,
      options: {
        excludedPaths: [`/404.html`],
      },
    },
    {
      resolve: "gatsby-plugin-anchor-links",
      options: {
        offset: -75,
      },
    },
    {
      resolve: `gatsby-plugin-facebook-multi-pixels`,
      options: [
        {
          dev: false,
          alias: "Fatshark",
          pixelId: "944017466309004",
          viewContent: true,
          pageView: true,
        },
      ],
    },
    {
      resolve: `gatsby-plugin-twitter-pixel`,
      options: {
        pixelId: "o8hem",
      },
    },
    {
      resolve: "gatsby-plugin-mailchimp",
      options: {
        endpoint:
          "https://fatshark.us20.list-manage.com/subscribe/post?u=21a5891c6dadd12c8fb7012bf&amp;id=96b04380d6", // string; add your MC list endpoint here; see instructions below
        timeout: 3500, // number; the amount of time, in milliseconds, that you want to allow mailchimp to respond to your request before timing out. defaults to 3500
      },
    },
    "gatsby-plugin-sass",
    "gatsby-plugin-react-helmet",
    "gatsby-plugin-sitemap",
  ],
};
